<template>
  <v-flex xs2 sm2 md2 lg2 xl2>
    <Modal :config="modalConfig" @save="logout">
      <span slot="modalContent" class="modal-content section-helpers">
        {{ $t('common.idleTimeoutContent') }}
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import IdleVueComponent from 'idle-vue/src/components/Idle.vue';
import Vue from 'vue';
import logoutMixin from '@/_core/mixins/logoutMixin';

Vue.component('idle-view', IdleVueComponent);

export default {
  name: 'IdleTimeout',
  components: {
    Modal: () => import('@/components/Modal.vue'),
  },
  mixins: [logoutMixin],
  data() {
    return {
      modalConfig: {
        enabled: false,
        icon: null,
        persistent: true,
        title: this.$t('common.idleTimeoutTitle'),
        saveButton: this.$t('common.login'),
        cancelButton: this.$t('common.cancel'),
        saveCallback: this.logout,
        width: 510,
        hideToolbar: true,
        deletePopup: false,
        close: true,
        rounded: true,
        alignCenter: true,
      },
    };
  },
  onIdle() {
    this.modalConfig.enabled = true;
  },
};
</script>

<style scoped>
.modal-content {
  font-weight: 300 !important;
  font-size: 16px !important;
  line-height: 3vh !important;
  letter-spacing: 0.5px !important;
}
</style>
